<script>
import { downloadFile } from '@/utils'
export default {
  name: 'FilePreview',
  components: {},
  props: {
    link: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      previewShow: false,
      previewUrl: '',
    };
  },
  computed: {

  },
  watch: {},
  mounted() {

  },
  methods: {
    /**
     * 点击文件列表中已上传文件时的回调
     */
    previewHandle() {
      const link = this.link
      if (!link) {
        return
      }
      const s_1 = link.lastIndexOf('/') + 1
      const s_2 = link.lastIndexOf('.')
      const ext = link.substring(s_2 + 1, link.length)
      const fileName = link.substring(s_1, s_2)
      if (['png', 'jpg', 'jpeg', 'gif'].indexOf(ext.toLowerCase()) === -1) {
        // 非图片类型，下载
        downloadFile(link, fileName + ext)
      } else {
        this.previewShow = true
        this.previewUrl = link;
      }
    },
  }
}
</script>

<template>
  <div>
    <div @click="previewHandle">
      <slot></slot>
    </div>
    <el-image-viewer
      v-if="previewShow"
      :url-list="[previewUrl]"
      :on-close="() => previewShow = false"
      append-to-body
    ></el-image-viewer>
  </div>
</template>
